import React, { useState } from 'react';
import '../styles/Requests.css';
import { updateProfile, changePassword } from '../api/auth';
import { INDUSTRIES } from '../constants/industries';

// Edit your own profile. Employer + industry are mandatory and shown to your direct links.
function Profile({ user, onUserUpdate }) {
  const [name, setName] = useState(user?.name || '');
  const [employer, setEmployer] = useState(user?.employer || '');
  const [industry, setIndustry] = useState(user?.industry || '');
  const [shareJobMoves, setShareJobMoves] = useState(user?.share_job_moves === true);
  const [saving, setSaving] = useState(false);
  const [notice, setNotice] = useState('');
  const [error, setError] = useState('');

  const submit = async (e) => {
    e.preventDefault();
    setNotice('');
    setError('');
    setSaving(true);
    try {
      const res = await updateProfile({ name, employer, industry, share_job_moves: shareJobMoves });
      setNotice('Saved.');
      if (onUserUpdate) onUserUpdate(res.user);
    } catch (err) {
      setError(err.message || 'Could not save');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="requests-container">
      <div className="requests-head">
        <h3>Your profile</h3>
        <p className="requests-sub">
          Employer and industry are shown to your direct links — it keeps the network honest.
        </p>
      </div>

      <form className="profile-form" onSubmit={submit}>
        <label>Full name
          <input type="text" value={name} onChange={(e) => setName(e.target.value)} placeholder="Your name" />
        </label>
        <label>Employer
          <input
            type="text"
            value={employer}
            onChange={(e) => setEmployer(e.target.value)}
            placeholder="Company name, or Freelancer / Own business"
            required
          />
        </label>
        <label>Industry
          <select value={industry} onChange={(e) => setIndustry(e.target.value)} required>
            <option value="" disabled>Select your industry…</option>
            {INDUSTRIES.map((ind) => (
              <option key={ind} value={ind}>{ind}</option>
            ))}
          </select>
        </label>
        <label className="consent-row">
          <input
            type="checkbox"
            checked={shareJobMoves}
            onChange={(e) => setShareJobMoves(e.target.checked)}
          />
          <span>
            <strong>Let companies I'm a verified contact of see when I change jobs.</strong>
            <span className="consent-sub">
              Off by default. Only companies you're already a confirmed contact of are told —
              just your name and the move (old → new employer). Never your network. You can turn this off anytime.
            </span>
          </span>
        </label>

        <button type="submit" className="btn-yes" disabled={saving}>
          {saving ? 'Saving…' : 'Save profile'}
        </button>
      </form>

      {notice && <div className="send-notice">{notice}</div>}
      {error && <div className="error-message">{error}</div>}

      <ChangePassword />
    </div>
  );
}

function ChangePassword() {
  const [current, setCurrent] = useState('');
  const [next, setNext] = useState('');
  const [saving, setSaving] = useState(false);
  const [notice, setNotice] = useState('');
  const [error, setError] = useState('');

  const submit = async (e) => {
    e.preventDefault();
    setNotice(''); setError(''); setSaving(true);
    try {
      await changePassword(current, next);
      setNotice('Password changed.');
      setCurrent(''); setNext('');
    } catch (err) {
      setError(err.message || 'Could not change password');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div style={{ marginTop: 28, borderTop: '1px solid #E3E5EA', paddingTop: 20 }}>
      <div className="requests-head">
        <h3>Change password</h3>
        <p className="requests-sub">At least 8 characters, with a letter and a number.</p>
      </div>
      <form className="profile-form" onSubmit={submit}>
        <label>Current password
          <input type="password" value={current} onChange={(e) => setCurrent(e.target.value)} required />
        </label>
        <label>New password
          <input type="password" value={next} onChange={(e) => setNext(e.target.value)} required />
        </label>
        <button type="submit" className="btn-yes" disabled={saving}>
          {saving ? 'Saving…' : 'Change password'}
        </button>
      </form>
      {notice && <div className="send-notice">{notice}</div>}
      {error && <div className="error-message">{error}</div>}
    </div>
  );
}

export default Profile;
